module.exports = __webpack_public_path__ + "static/media/kaboom.45697063.mp3";